import React from 'react';
import { CTASection } from '../../components/CTASection';
export function SupportCTA() {
  return <section className="py-20 bg-white" data-id="element-640">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-641">
        <CTASection headline="Ready to Start Your Project?" body="Let's discuss how our structured approach can guarantee the success of your next software initiative." buttonText="Get in Touch" buttonLink="/contact" variant="dark" data-id="element-642" />
      </div>
    </section>;
}